<div class="cockpit-content">
  <h1>{{card.title | translate}}</h1>
  <h2>{{'m1-m2.sprint7.cockpit.card.pruefung-der-variablen.subtitle.1' | translate}}</h2>
  <!-- table 1 -->
  <app-chart-download-button (buttonClick)="downloadTable()">
    <h3 class="title" translate>sprint9.cockpit.card.all.tabelle</h3>
  </app-chart-download-button>

  <div class="table-wrapper pdb-30">
    @if (pruefungDerVariablen) {
      <table class="hover-focus" id="pruefungDerVariablenVerteilungProVariableM1">
        <thead>
          <tr>
            <td class="no-border"><br></td>
            <th scope="col" rowspan="2" class="header bold centered border-bold-left">
            {{'m1-m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.min' | translate }}</th>
            <th scope="col" rowspan="2" class="header bold centered border-bold-left">
            {{'m1-m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.quartil.1' | translate }}</th>
            <th scope="col" rowspan="2" class="header bold centered border-bold-left">
            {{'m1-m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.median' | translate }}</th>
            <th scope="col" rowspan="2" class="header bold centered border-bold-left">
            {{'m1-m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.durchschnitt' | translate }}</th>
            <th scope="col" rowspan="2" class="header bold centered border-bold-left">
            {{'m1-m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.quartil.3' | translate }}</th>
            <th scope="col" rowspan="2" class="header bold centered border-bold-left border-bold-right">
            {{'m1-m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.max' | translate }}</th>
          </tr>
          <tr>
            <td class="header border-bold-left"><br></td>
          </tr>
        </thead>
        <tbody>
          <tr appPruefungDerVariablenTableRow [rowdata]="pruefungDerVariablen.Alter"
            [rowHeader]="'m1-m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.alter'" [crtLocale]="crtLocale"
            [minFractioningDigits]="1">
          </tr>
          <tr appPruefungDerVariablenTableRow [rowdata]="pruefungDerVariablen.Ausbildungsjahre"
            [rowHeader]="'m1.sprint7.cockpit.card.chart.pruefung-der-variablen.table.ausbildungsjahre'"
            [crtLocale]="crtLocale" [minFractioningDigits]="1">
          </tr>
          <tr appPruefungDerVariablenTableRow [rowdata]="pruefungDerVariablen.PotenzielleErwerbsjahre"
            [rowHeader]="'m1-m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.potenzielleErwerbsjahre'"
            [crtLocale]="crtLocale" [minFractioningDigits]="1">
          </tr>
          <tr appPruefungDerVariablenTableRow [rowdata]="pruefungDerVariablen.Dienstjahre"
            [rowHeader]="'m1-m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.dienstjahre'" [crtLocale]="crtLocale"
            [minFractioningDigits]="1">
          </tr>
          <tr appPruefungDerVariablenTableRow [rowdata]="pruefungDerVariablen.AnMonatslohnBeschaeftigungsgrad"
            [rowHeader]="'m1-m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.beschaeftigungsgrad'"
            [crtLocale]="crtLocale" [minFractioningDigits]="1">
          </tr>
          <tr appPruefungDerVariablenTableRow
            [rowdata]="pruefungDerVariablen.AnStundenlohnAnzahlBezahlteStundenImReferenzmonat"
            [rowHeader]="'m1-m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.anzahlBezahlteStunden'"
            [crtLocale]="crtLocale" [minFractioningDigits]="1">
          </tr>
          <tr appPruefungDerVariablenTableRow [rowdata]="pruefungDerVariablen.Grundlohn"
            [rowHeader]="'m1-m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.grundlohn'" [crtLocale]="crtLocale"
            [minFractioningDigits]="1">
          </tr>
          <tr appPruefungDerVariablenTableRow [rowdata]="pruefungDerVariablen.Zulagen"
            [rowHeader]="'m1-m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.zulage'" [crtLocale]="crtLocale"
            [minFractioningDigits]="1">
          </tr>
          <tr appPruefungDerVariablenTableRow [rowdata]="pruefungDerVariablen.DreizehnterMonatslohn"
            [rowHeader]="'m1-m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.monatslohn13'" [crtLocale]="crtLocale"
            [minFractioningDigits]="1">
          </tr>
          <tr appPruefungDerVariablenTableRow [rowdata]="pruefungDerVariablen.Sonderzahlungen"
            [rowHeader]="'m1-m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.sonderzahlungen'"
            [crtLocale]="crtLocale" [minFractioningDigits]="1">
          </tr>
          <tr appPruefungDerVariablenTableRow [rowdata]="pruefungDerVariablen.StandardisierterGesamtVerdienst"
            [rowHeader]="'m1-m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.gesamtverdienst'"
            [crtLocale]="crtLocale" [minFractioningDigits]="1">
          </tr>
          <tr appPruefungDerVariablenTableRow [rowdata]="pruefungDerVariablen.BetrieblicheWoechentlicheArbeitszeit"
            [rowHeader]="'m1-m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.buwazInStunden'"
            [crtLocale]="crtLocale" [minFractioningDigits]="1">
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td class="hint" colspan="7">
              {{'m1-m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table1.hinveise-grundgesamtheit-gueltig' |
            translate}}</td>
          </tr>
        </tfoot>
      </table>
    }
  </div>

  <h2>{{'m1-m2.sprint7.cockpit.card.pruefung-der-variablen.subtitle.2' | translate}}</h2>
  <!-- table 2 -->
  <app-effektive-ausbildung
    [data]="ausbildung"
    [downloadTxtKey]="'sprint9.cockpit.card.all.tabelle'"
    [columnTxtKey]="'m1.sprint7.cockpit.card.chart.pruefung-der-variablen.table2.ausbildung'"
    [tableBottomTxtKey]="'m1-m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table2.hinveise-grundgesamtheit-gueltig-mitarbeiter'"
    [filename]="card.title"
    >
  </app-effektive-ausbildung>
</div>
